import { TOAST_TX_MSG } from "@/features/bridge/constants/toast-msgs.constants";
import type { CustomToastType } from "@components/layout/toast/styled-toast";
import Toast from "@components/layout/toast/styled-toast";
import toast from "react-hot-toast";

//$ SHOW TOAST
export const showToast = ({ toastContent, buttonContent }: CustomToastType) => {
  return toast.custom(
    (t) => (
      <Toast
        toastContent={toastContent}
        buttonContent={buttonContent}
        toastData={t}
      />
    ),
    {
      duration: 6000,
    },
  );
};

//$ GENERIC SUCCESS TOAST
export const showToastTxSuccess = (transactionHash: string) => {
  showToast({
    toastContent: TOAST_TX_MSG.TX_SUCCESS.toastContent,
    buttonContent: {
      ...TOAST_TX_MSG.TX_SUCCESS.buttonContent,
      btnLink: `${TOAST_TX_MSG.TX_SUCCESS.buttonContent.btnLink}/tx/${transactionHash}`,
    },
  });
};

//$ GENERIC REVERT
export const showToastTxRevert = () => {
  showToast({
    toastContent: TOAST_TX_MSG.TX_REVERTED.toastContent,
  });
};
